import { CALENDLY_WIDGET_URL } from 'routes/constants'
import { CalendlyWidget } from 'routes/components/Shared'
import classes from './BookADemoCalendly.module.scss'

export const BookADemoCalendly = () => {
  return (
    <section className={classes.section}>
      <CalendlyWidget calendlyUrl={CALENDLY_WIDGET_URL} isStyled />
    </section>
  )
}
